<ion-content class="modal-options ion-padding">
  <ng-container>
    <div class="modal-form-container">
      <div class="content-top">
        <!-- Title and close button header -->
        <div
          class="modal-header"
          [ngClass]="{
            'modal-header-ios': platform === 'ios'
          }"
        >
          <h3 class="title">
            {{ modalTitle | translate }}
          </h3>

          <button
            type="button"
            class="close-button"
            (click)="closeModal()"
            aria-label="Cerrar modal"
          >
            <ion-icon name="close" class="close-icon"></ion-icon>
          </button>
        </div>
        <!-- Message to share -->
        <div class="message-to-share">
          <div class="message-box">
            <p class="message-text">{{ baseMessage }}</p>
            @if (ticketLink) {
            <a target="_blank" class="ticket-link" [href]="ticketLink">
              <span class="typewriter-text">{{
                animatedLink || ticketLink
              }}</span>
            </a>
            } @if (!ticketLink) {
            <span class="placeholder-link">{{
              "share-birthday-message-modal.link-to-share" | translate
            }}</span>
            }
          </div>
        </div>
        <div class="link-container">
          <p class="label-link">
            {{ "share-birthday-message-modal.label-link" | translate }}
          </p>
          <p class="subtitle-link">
            {{ "share-birthday-message-modal.subtitle-link" | translate }}
          </p>
          <app-input-form
            [control]="referenceControl"
            type="text"
            placeholder="share-birthday-message-modal.placeholder-link"
            [showBorder]="false"
          />
          <!-- Button to show  event selector -->
          <button
            type="button"
            class="btn-gift"
            [class.btn-gift--active]="showSelectors"
            aria-label="Agregar Gift Ticket"
            (click)="toggleSelectors()"
          >
            <ion-icon name="ticket-outline" class="btn-gift__icon"></ion-icon>
            <span>{{
              "share-birthday-message-modal.button-add-gift-ticket" | translate
            }}</span>
          </button>

          <!-- Alert -->
          @if (showSelectors) {
          <div class="range-description">
            <ion-icon
              name="information-circle-outline"
              class="help-icon"
            ></ion-icon>
            <span class="description-text">
              {{ "share-birthday-message-modal.description-link" | translate }}
            </span>
          </div>
          }

          <!-- Selectors container -->
          @if (showSelectors) {
          <div class="selector-container">
            <!-- No events message -->
            @if (promotionalEvents.length === 0) {
            <div>
              <app-empty-state
                [title]="'No se detectan productos promocionales asignados'"
                [subtitle]="'Serán visibles aquí cuando se te asignen.'"
                [showImage]="true"
              />
            </div>
            }
            <!-- Event selector -->
            @if (promotionalEvents.length > 0) {
            <div class="selector-item">
              <ion-select
                placeholder="Selecciona un evento"
                (ionChange)="onEventSelectedById($event.detail.value)"
                [interface]="'popover'"
                [interfaceOptions]="{ header: 'Seleccionar Evento' }"
              >
                @for (event of promotionalEvents; track event.id) {
                <ion-select-option [value]="event.id">
                  {{ event.name }}
                </ion-select-option>
                }
              </ion-select>
            </div>
            }
            <!-- Product selector -->
            @if (selectedEvent && promotionalEvents.length > 0) {
            <div class="selector-item">
              <ion-select
                placeholder="Selecciona un Producto Promocional"
                (ionChange)="onProductSelectedById($event.detail.value)"
                [interface]="'popover'"
                [interfaceOptions]="{
                  header: 'Seleccionar Producto Promocional'
                }"
                [disabled]="loadingProducts || promotionalProducts.length === 0"
              >
                @for (product of promotionalProducts; track product.id) {
                <ion-select-option [value]="product.id">
                  {{ product.name }}
                </ion-select-option>
                }
              </ion-select>
            </div>
            }
            <!-- Loading state -->
            @if (loadingProducts && promotionalEvents.length > 0) {
            <div class="loading-container">
              <ion-spinner name="crescent"></ion-spinner>
              <span>{{
                "share-birthday-message-modal.loading-products" | translate
              }}</span>
            </div>
            }
            <!-- No products message -->
            @if ( selectedEvent && !loadingProducts &&
            promotionalProducts.length === 0 && promotionalEvents.length > 0 ) {
            <div class="no-products-message">
              <ion-icon name="information-circle-outline"></ion-icon>
              <span>{{
                "share-birthday-message-modal.no-products-message" | translate
              }}</span>
            </div>
            }
          </div>
          }
        </div>

        <div
          class="filter-buttons"
          [ngClass]="{
            'filter-buttons-ios': platform === 'ios'
          }"
        >
          <app-main-button
            [label]="'share-birthday-message-modal.send-message'"
            (clicked)="sendMessage()"
          />

          <a
            class="whatsapp-full-button"
            href="https://wa.me/{{ assistant.phone }}"
            target="_blank"
          >
            <span>
              {{ "share-birthday-message-modal.whatsapp-direct" | translate }}
            </span>
          </a>
        </div>
      </div>
    </div>
  </ng-container>
</ion-content>
